import React from 'react';
import './HeaderLanding.scss';
import { FaArrowRight } from 'react-icons/fa6';

const images = {
  "1": "https://framerusercontent.com/images/qqyVwS7bcaeIG999myKSd8TiI.jpg",
  "2": "https://framerusercontent.com/images/OSvn1941qAlQoCWupbhWCuVbWA.jpg",
  "3": "https://framerusercontent.com/images/yXwWijXOXxc1OIdWXTQrjKlVo.jpg"
};

const HeaderLanding: React.FC = () => {
  const openWhatsApp = () => {
    window.open('https://wkf.ms/43mTnyz', '_blank');
  };

  return (
    <header className="hero" id="header">
      <div className="hero__text">
        <span className="hero__badge">Plataforma Gastronómica Inteligente</span>
        <h1 className="hero__title">
          El sistema operativo
          <br />
          de tu restaurante
        </h1>
        <p className="hero__subtitle">
          Ventas, inventario, personal, reservas y delivery unificados
          en una sola plataforma impulsada por IA.
        </p>
        <div className="hero__actions">
          <button className="hero__cta" onClick={openWhatsApp}>
            Solicitar demo <FaArrowRight />
          </button>
          <button
            className="hero__cta-secondary"
            onClick={() => {
              const el = document.getElementById('features');
              el?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Ver soluciones
          </button>
        </div>
      </div>
      <div className="hero__images">
        <img src={images["1"]} alt="Dashboard del restaurante" className="hero__img" />
        <img src={images["2"]} alt="Gestión de órdenes" className="hero__img" />
        <img src={images["3"]} alt="Vista del equipo" className="hero__img" />
      </div>
    </header>
  );
};

export default HeaderLanding;
